import {
  BulkEmailTaskTarget,
  BulkEmaiUserSelectionProps,
} from '../interface/interface';
import BulkEmailUserSelection from './BulkEmailUserSelection';
import BulkEmailPrescriptionSelection from './BulkEmailPrescriptionSelection';

const BulkEmailFilterSelection = (props: BulkEmaiUserSelectionProps) => {
  return (
    <>
      {props?.filters?.userType.value ===
      BulkEmailTaskTarget.Patient ? (
        <BulkEmailUserSelection
          token={props.token}
          setValidTemplate={props.setValidTemplate}
          filters={props.filters!}
          setFilters={props.setFilters}
        />
      ) : (
        <BulkEmailPrescriptionSelection
          token={props.token}
          setValidTemplate={props.setValidTemplate}
          filters={props.filters!}
          setFilters={props.setFilters}
        />
      )}
    </>
  );
};

export default BulkEmailFilterSelection;
